const initialState = {
	open: false,
	quickAddedUser: false
}

const actionTypes = {
    OPEN_REPORT_VIEWER_DIALOG: "OPEN_REPORT_VIEWER_DIALOG",
    CLOSE_REPORT_VIEWER_DIALOG: "CLOSE_REPORT_VIEWER_DIALOG",
		QUICK_ADDED_USER: "QUICK_ADDED_USER",
}

export function openReportViewerDialog(){
    return {
        type: actionTypes.OPEN_REPORT_VIEWER_DIALOG,
    }
}

export function closeReportViewerDialog(){
    return {
        type: actionTypes.CLOSE_REPORT_VIEWER_DIALOG,
    }
}

export function quickAddedUser() {
	return {
		type: actionTypes.QUICK_ADDED_USER
	}
}

export default function (state = initialState, action) {
	switch (action.type) {
	  case actionTypes.OPEN_REPORT_VIEWER_DIALOG:{
		  return { 
			  ...state,
			  open: true,
		  }
	  }
	  case actionTypes.CLOSE_REPORT_VIEWER_DIALOG:{
			return { 
				...state,
				open: false,
			}
	  }
		case actionTypes.QUICK_ADDED_USER: {
			return {
				...state,
				quickAddedUser: !state.quickAddedUser
			}
		}
	  default:
		return state
	}
}